import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import { MCBQS060SearchRequest } from "types/MCBQS060/MCBQS060SearchRequest"
import * as apiConfig from 'pages/MCBQS060/apiConfig'
import { MCBQS060ViewErrorCheckModalRequest } from "types/MCBQS060/MCBQS060ViewErrorCheckModalRequest"
import { MCBQS060TransitionSubmissionRequestListRequest } from "types/MCBQS060/MCBQS060TransitionSubmissionRequestListRequest"
import { MCBQS060DeletePdfDownloadRecordRequest } from "types/MCBQS060/MCBQS060DeletePdfDownloadRecordRequest"
import { setPdfSearchCondition } from "./mcbPdfDownloadReducer"


interface setPdfDownload {
  // 初期表示
  setPdfManagementInit: MCBQS060SearchRequest
  selectionManagementOption: string
  setPdfManagementResultList: setPdfManagementResult[]
  MCBLS010RefreshFlag: string
  MCBQS060RefreshFlag: string
  errorConfirmDialogOpenFlag: boolean
  errorConfirmInfo: ErrorConfirm
  setPrintManagementSearchCondition:MCBQS060SearchRequest
  isLoading: boolean
}

export interface ErrorConfirm {
  errorDivision: string
  errorContent: string
}

// 一覧画面の検索結果
export interface setPdfManagementResult {
  [key: string]: string | number | null
  setPrintManagementId: number
  outputTitle: string //タイトル
  outputSubmissionContent: string
  status: string //状態
  errorDivision: string
  targetCount: string //提出件数
  executionUserId: number
  fullName: string //実行者
  executionDatetime: string //実行日時
  downloadDatetime: string //ダウンロード日時
}


const initialState: setPdfDownload = {
  setPdfManagementInit: apiConfig.initRequest,
  selectionManagementOption: '',
  setPdfManagementResultList: [],
  MCBLS010RefreshFlag: '',
  MCBQS060RefreshFlag: '',
  errorConfirmDialogOpenFlag: false,
  errorConfirmInfo: apiConfig.initErrorConfirm,
  setPrintManagementSearchCondition: apiConfig.initRequest,
  isLoading: true,
}

const setPdfManagementSlice = createSlice({
  name: 'setPdfManagement',
    initialState,
  reducers: {
    getInitSetPdf(state, action: PayloadAction<MCBQS060SearchRequest>) {
      state.setPdfManagementInit = action.payload
      return state
    },
    setSetPdfManagementResult(state, action: PayloadAction<setPdfManagementResult[]>) {
      state.setPdfManagementResultList = action.payload
      return state
    },
    setSelectionManagementOption(state, action:PayloadAction<string>) {
      state.selectionManagementOption = action.payload
      return state
    },
    getFindResult(state, action: PayloadAction<MCBQS060SearchRequest>) {
      return state
    },
    setMCBLS010RefreshFlag(state, action: PayloadAction<string>) {
      state.MCBLS010RefreshFlag = state.MCBLS010RefreshFlag === '1' ? '2' : '1'
      return state
    },
    setMCBQS060RefreshFlag(state, action: PayloadAction<string>) {
      state.MCBQS060RefreshFlag = state.MCBQS060RefreshFlag === '1' ? '2' : '1'
      return state
    },
    getErrorConfirmInfo(state, action: PayloadAction<MCBQS060ViewErrorCheckModalRequest>) {
      return state
    },
    setErrorConfirmDialog(state, action: PayloadAction<boolean>) {
      state.errorConfirmDialogOpenFlag = action.payload
      return state
    },
    setErrorConfirmInfo(state, action: PayloadAction<ErrorConfirm>) {
      state.errorConfirmInfo = action.payload
      return state
    },
    toMCAXS010Search(state, action: PayloadAction<MCBQS060TransitionSubmissionRequestListRequest>) {
      return state
    },
    deleteSetPrintManagement(state, action: PayloadAction<MCBQS060DeletePdfDownloadRecordRequest>) {
      return state
    },
    setSearchCondition(state, action: PayloadAction<MCBQS060SearchRequest>) {
      state.setPrintManagementSearchCondition = action.payload
    },
    startLoading(state) {
      state.isLoading = true;
    },
    finishLoading(state) {
      state.isLoading = false;
    },
  },
})

export const {
  getInitSetPdf,
  setSetPdfManagementResult,
  setSelectionManagementOption,
  getFindResult,
  setMCBLS010RefreshFlag,
  setMCBQS060RefreshFlag,
  getErrorConfirmInfo,
  setErrorConfirmDialog,
  setErrorConfirmInfo,
  toMCAXS010Search,
  deleteSetPrintManagement,
  setSearchCondition,
  startLoading,
  finishLoading,
} = setPdfManagementSlice.actions

export default setPdfManagementSlice.reducer